"use strict";

import jQuery from 'jquery';

/**
 * Listentype.
 */
gc.gis.widget.GCListType = {
    /**
     * einfache Liste
     */
    SIMPLE: 'simple',
    /**
     * verlinkte Liste
     */
    LINKED: 'linked',
    /**
     * Button Liste
     */
    BUTTON: 'button'
};


/**
 * @classdesc
 * Listen-Widget zur Verwaltung von Listenelementen.
 *
 * @class
 * @extents gc.gis.widget.GCWidget
 * @memberof gc.gis.widget
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 *
 * @param {Object} options Aufrufoptionen
 * @param {string} options.id HTML-ID dieses Widgets
 * @param {string} options.target HTML-ID des Zielkontainers
 * @param {number} [options.order] optionaler Anordnungsindex
 * @param {string} [options.className=''] CSS-Klasse(n) für den Container
 * @param {string} [options.listType=gc.gis.widget.GCListType.SIMPLE] {@link gc.gis.widget.GCListType|Listentyp}
 */
gc.gis.widget.GCList = function(options)
{
    gc.gis.widget.GCWidget.call(this, options);

    this._listtype = options.listType || gc.gis.widget.GCListType.SIMPLE;
    /**
     * @type {jQuery[]}
     * @private
     */
    this._items = [];
};
gc.gis.widget.GCList.prototype = Object.create( gc.gis.widget.GCWidget.prototype );

/**
 * @inheritdoc
 */
gc.gis.widget.GCList.prototype._render = function()
{
    // Container
    if(!this.element)
    {
        switch (this._listtype) {
            case gc.gis.widget.GCListType.LINKED:
            case gc.gis.widget.GCListType.BUTTON:
                this.element = jQuery('<div>', {
                    'class': 'gc-widget-list list-group'
                    + (this.className ? ' ' + this.className : '')
                });
                break;
            default:
                this.element = jQuery('<ul>', {
                    'class': 'gc-widget-list list-group'
                    + (this.className ? ' ' + this.className : '')
                });
        }

        if( this.id )
        {
            this.element.attr('id', this.id);
        }
    }
    else
    {
        this.clear();
    }

    return this.element;
};

/**
 * Leert den Container.
 *
 * @method
 * @public
 */
gc.gis.widget.GCList.prototype.clear = function()
{
    if(this.element)
    {
        this.element.children().remove();
        this._items = [];
    }
};

/**
 * Liefert die Anzahl der Elemente des Containers.
 *
 * @method
 * @return {int}
 * @public
 */
gc.gis.widget.GCList.prototype.numItems = function()
{
    return this._items.length;
};

/**
 * Liefert das Element zum Eintrag am angegeben Index.
 *
 * @method
 * @param {int} index Index des abgefragten Eintrags
 * @return {jQuery|null} Item-Element
 * @public
 */
gc.gis.widget.GCList.prototype.getItem = function(index)
{
    if (index >= 0 && index < this._items.length)
    {
        return this._items[index];
    }

    return null;
};

/**
 * Fügt ein Eintrag dem Container hinzu.
 *
 * @method
 * @param {string} label Label des Listenelement
 * @param {Object} [opt_options] optionale Optionen
 * @param {string} [opt_options.badge] Badge anzeigen
 * @param {boolean} [opt_options.active] Eintrag aktiviert darstellen
 * @param {boolean} [opt_options.disabled] Eintrag gesperrt darstellen
 * @param {string} [opt_options.href] Linkziel bei Listen vom Typ gis.widget.GCListType.LINKED
 * @param {function} [opt_options.click] Callback, die beim Klick auf das Item aufgerufen wird
 * @param {function} [opt_options.enter] Callback, die beim Betreten des Items mit der Maus aufgerufen wird
 * @param {function} [opt_options.leave] Callback, die beim Verlassen des Items mit der Maus aufgerufen wird
 * @return {jQuery}
 * @public
 */
gc.gis.widget.GCList.prototype.addItem = function(label, opt_options)
{
    var item;
    var html = '';
    opt_options = opt_options || {};

    switch (this._listtype) {
        case gc.gis.widget.GCListType.LINKED:
            item = jQuery('<a>', {
                'class': 'list-group-item',
                href: opt_options.href || '#'
            });
            break;
        case gc.gis.widget.GCListType.BUTTON:
            item = jQuery('<button>', {
                'class': 'list-group-item',
                type: 'button'
            });
            break;
        default:
            item = jQuery('<li>', {
                'class': 'list-group-item'
            });
            break;
    }

    if (opt_options.badge) {
        html += '<span class="badge">' + opt_options.badge + '</span>';
    }
    html += label;

    item.html(html);
    if (opt_options.active) {
        item.addClass('active');
    }
    if (opt_options.disabled) {
        item.addClass('disabled');
    }

    // Element den Containern hinzufügen
    var length = this._items.push(item);
    this.getElement().append(item);

    // ggf. Event-Handler registrieren
    if (opt_options.click && typeof opt_options.click == 'function') {
        item.click(function (evt) {
            opt_options.click.call(self, length-1, evt);
        });
    }

    if (opt_options.enter && typeof opt_options.enter == 'function') {
        item.mouseenter(function (evt) {
            opt_options.enter.call(self, length-1, evt);
        });
    }

    if (opt_options.leave && typeof opt_options.leave == 'function') {
        item.mouseleave(function (evt) {
            opt_options.leave.call(self, length-1, evt);
        });
    }

    return item;
};

/**
 * Setzt den Badge-Inhalt zu einem Eintrag zum angegeben Index.
 *
 * @method
 * @param {int} index Index des Eintrags
 * @param {string} badge neuer Badge-Inhalt
 * @public
 */
gc.gis.widget.GCList.prototype.setItemBadge = function(index, badge)
{
    var item = this.getItem(index);
    if (item)
    {
        var badge_element = item.find('.badge');
        if (badge_element) {
            badge_element.html(badge);
        }
    }
};